import { filter } from 'lodash';
import { flatten } from '../utils/flatten';

/**
 * Ritorna un oggetto chiave-valore dove la chiave è il percorso
 * al campo (es. `foo.bar`) e il valore è true per i campi modificati
 */
export function flattenDirtyFields(dirtyFields: any) {
  const flattened = flatten(dirtyFields);
  // console.log('dirtyFields', flattened);
  return filter(flattened, value => value);
}

export function hasDirtyFields(dirtyFields: any) {
  return Object.keys(flattenDirtyFields(dirtyFields)).length > 0;
}
